import { AgendaMagasinTunnel } from '@components/agenda-magasin-tunnel/models';
import { Block } from '@shared/models';

export const agendaMagasinTunnelMock: Block<AgendaMagasinTunnel> = {
  type: 'agenda-magasin-tunnel',
  data: {
    title: {
      text: `Alors on se voit quand ?`,
      as: 'span',
    },
    contactBanner: {
      picto: {
        svg: '/assets/tmp/store.svg',
      },
      text: `<strong>Vous ne trouvez pas le créneau qui vous convient ?</strong><br/>Appelez-nous au magasin au <strong>#PHONE#</strong>`,
    },
    gtmConfigCallBtn: {
      event: 'click_cta_appel_rdv',
      group: 'appel',
      description: 'bloc rdv tunnel rdv',
      context: 'clic pour appeler',
    },
  },
};
